import { EventEmitter, Injectable } from "@angular/core";
import { take, timeout } from "rxjs/operators";
import { ICacheNativeService } from "./icache-native";
import { LogService } from "../../log/log.service";
import { CacheService } from "./v2/cache.service";
import { TYPEACTIONCACHE } from "./model/cache-native.model";

declare const localDataBaseAndroid;

declare global {
  interface Window {
    localDataBaseResponse: (data: any) => any;
    webkit: any;
    JSBridge: any;
  }
}

@Injectable({ providedIn: "root" })
export class CacheNativeService implements CacheService {
  private EmmitChange = new EventEmitter<{ data }>();
  private reg: RegExp = new RegExp("(error|Error|erro|Erro)|(400|500|404|406)");

  constructor(private logService: LogService) {
    window.localDataBaseResponse = (data: string) => {
      this.EmmitChange.emit({ data });
    };
  }

  setItemCommunicator(params?: object): Promise<void> {
    /**
     * Send mensage for IOS or Android
     */

    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.localDataBaseIOS
    ) {
      this.comunicationIOS(TYPEACTIONCACHE.SET, params);
    } else {
      this.comunicationAndroid(TYPEACTIONCACHE.SET, params);
    }
    return Promise.resolve();
  }

  deleteItemCommunicator(): Promise<void> {
    /**
     * Send mensage for IOS or Android
     */

    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.localDataBaseIOS
    ) {
      this.comunicationIOS(TYPEACTIONCACHE.DELETE);
    } else {
      this.comunicationAndroid(TYPEACTIONCACHE.DELETE);
    }
    return Promise.resolve();
  }

  getItemCommunicator<T>(): Promise<T> {
    /**
     * Send mensage for IOS or Android
     */

    this.logService.save(
      "solicitando dados",
      "CacheNativeService.getItemCommunicator"
    );
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.localDataBaseIOS
    ) {
      this.comunicationIOS(TYPEACTIONCACHE.GET);
    } else {
      this.comunicationAndroid(TYPEACTIONCACHE.GET);
    }

    return new Promise((resolve, reject) => {
      this.EmmitChange.pipe(take(1)).subscribe((value) => {
        this.logService.save(
          "solicitando dados",
          "CacheNativeService.getItemCommunicator.EmmitChange"
        );
        this.logService.save(
          JSON.stringify(value),
          "CacheNativeService.getItemCommunicator.EmmitChange"
        );
        if (value.data) {
          if (this.reg.test(value.data)) {
            reject(value.data);
          }
        }
        resolve(value.data);
      });
    });
  }

  private comunicationIOS(type: string, params?: object) {
    const value = JSON.stringify({
      type,
      params,
    });
    window.webkit.messageHandlers.localDataBaseIOS.postMessage(value);
  }

  private comunicationAndroid(type: string, params?: object) {
    this.logService.save(
      type + ":" + params,
      "CacheNativeService.comunicationAndroid"
    );
    try {
      const paramsValue = JSON.stringify({ params });
      localDataBaseAndroid.postMessage(type, paramsValue);
    } catch (error) {}
  }

  getMockContaIon() {
    return {
      type: "basic",
      steps: [
        { percentage: 0, stepId: "personal-data", stepName: "Dados Pessoais" },
        { percentage: 0, stepId: "marital-status", stepName: "Estado Civil" },
        { percentage: 0, stepId: "address", stepName: "Endereço" },
        {
          percentage: 0,
          stepId: "professional-data",
          stepName: "Dados Profissionais",
        },
        {
          percentage: 0,
          stepId: "income-equity",
          stepName: "Renda e patrimônio",
        },
      ],
      data: {
        personalData: {
          cpf: "92898863823",
          isCompleted: false,
          name: "Italo",
          documentTypeName: "RG",
          documentType: "551",
          documentName: "Italo paolo",
          documentNumber: "1231231231",
          issuingAgencyName: "ASLEGIS",
          issuingAgency: "179",
          expeditionStateName: "ACRE",
          expeditionState: "AC",
          motherName: "Maria ana",
          nationalityName: "BRASILEIRA",
          nationality: "648",
          countryOfBirthName: "BRASIL",
          countryOfBirth: "BR",
          uFOfBirthName: "ACRE",
          uFOfBirth: "AC",
          cityOfBirth: "1200013",
          cityOfBirthName: "ACRELANDIA",
          genderName: "MASCULINO",
          gender: "1192",
          genderCode: "MASCULINO",
          age: "54"
        },
        maritalStatus: {
          firstEdit: [],
          maritalStatusName: "SOLTEIRO",
          maritalStatus: "617",
          foreignSpouse: false,
        },
        professionalData: {
          firstEdit: [],
          originIncomeName: "EMPREGADO EMPRESA PRIVADA",
          originIncome: "11829",
          professionName: "ADMINISTRADOR",
          profession: "960",
          entityThatWorks: "ITAU UNIBANCO HOLDING S.A.",
          entityCnpj: "60872504000123",
        },
        incomeEquity: {
          firstEdit: [],
          noIncome: false,
          income: "1234.23",
          noPatrimony: false,
          patrimony: "23423.42",
          taxResidence: "BR",
          taxResidenceName: "BRASIL",
        },
        address: {
          firstEdit: [],
          street: "JOSE JORGE FONTE BOA",
          state: "MG",
          city: "BELO HORIZONTE",
          district: "HAVAI",
          postalCode: "30570-250",
          number: "345",
          adjunct: "",
        },
      },
    };
  }
}
